import { formatDate } from "app/utils/filters";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Active From",
    render: (row) => formatDate(row.active_from),
  },
  {
    name: "Active To",
    render: (row) => (row.active_to ? formatDate(row.active_to) : "∞"),
  },
  {
    name: "Rate",
    render: (row) => `${row.rate}%`,
  },
  {
    name: "Dynamic",
    render: (row) => (row.dynamic ? "✅" : "❌"),
  },
];

export default columnConfigs;
